import styled from 'styled-components';
import {
  DOC_CARD_TEMPLATE_COLUMNS,
  INNER_DOC_CARD_TEMPLATE_COLUMNS,
  SUPERVISOR_DOC_CARD_TEMPLATE_COLUMNS,
} from '../Documents/style';

export const PageContainer = styled.div`
  padding: 3rem 2rem 4rem;
`;

export const Title = styled.div`
  display: flex;
  justify-content: space-between;

  @media ${(props) => props.theme.device.mobileL} {
    flex-direction: column;
  }
`;

export const DocumentUpload = styled.div`
  background-color: #eff5fb;
  padding: 20px 24px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  column-gap: 40px;
  height: fit-content;

  @media ${(props) => props.theme.device.mobileL} {
    flex-direction: column;
    align-items: start;
    row-gap: 24px;
    padding: 16px;
    margin-bottom: 12px;

    button {
      margin-left: auto;
    }
  }
`;

export const FiltersWrapper = styled.div`
  margin-bottom: 2rem;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 1rem;
`;

export const SelectWrapper = styled.div`
  min-width: 115px;
  width: fit-content;
`;

export const Legend = styled.div`
  display: grid;
  grid-template-columns: ${DOC_CARD_TEMPLATE_COLUMNS};
  gap: 24px;
  padding-bottom: 24px;
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 16px;
  color: ${(props) => props.theme.colors.textSecondary};

  p {
    text-transform: uppercase;
  }

  &.inner-documents {
    grid-template-columns: ${INNER_DOC_CARD_TEMPLATE_COLUMNS};
  }
  &.supervisor-documents {
    grid-template-columns: ${SUPERVISOR_DOC_CARD_TEMPLATE_COLUMNS};
  }
`;

export const DocumentsGrid = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding-bottom: 3rem;

  @media ${(props) => props.theme.device.mobileL} {
    gap: 0;
  }
`;
